// The In-line Cost Sheets guide (39_BenchmarkLibrary.jsx · ModuleHelp, Max 01/11).
const en = {
  introT: 'A library of vendor cost sheets',
  introB: 'Keeps the in-line cost sheets vendors send, so a line can be reused later. The Pricing Calculator picks its benchmark lines from here.',
  searchT: 'Find a sheet',
  searchB: 'Type to narrow the cards by style, file name, season or vendor.',
  importT: 'File a new sheet',
  importB: 'Pick the vendor\'s Excel workbook (.xlsx). The lines are read and checked against the cost printed beside them; any line that does not add up is listed by name instead of being dropped.',
  cardT: 'Open a sheet',
  cardB: 'Click a card to see its lines: Skin, CMT, OH&P and frame against the sheet\'s own stated total. Edit sets season, vendor and note; Remove deletes the sheet from the library.',
};
const ko = {
  introT: '벤더 원가표 라이브러리',
  introB: '벤더가 보낸 인라인 원가표를 보관해 두었다가 나중에 다시 쓸 수 있습니다. Pricing Calculator의 벤치마크 라인도 여기서 가져옵니다.',
  searchT: '원가표 찾기',
  searchB: '입력하면 스타일, 파일명, 시즌, 벤더 기준으로 카드가 좁혀집니다.',
  importT: '새 원가표 등록',
  importB: '벤더의 Excel 워크북(.xlsx)을 선택하세요. 라인을 읽어 옆에 적힌 원가와 맞는지 확인하며, 맞지 않는 라인은 버리지 않고 이름을 밝혀 알려 줍니다.',
  cardT: '원가표 열기',
  cardB: '카드를 누르면 라인이 보입니다. Skin, CMT, OH&P, 프레임과 원가표 자체의 합계를 비교할 수 있습니다. 수정은 시즌, 벤더, 메모를 바꾸고 삭제는 라이브러리에서 원가표를 지웁니다.',
};
const vi = {
  introT: 'Thư viện bảng giá vendor',
  introB: 'Lưu các bảng cost sheet in-line mà vendor gửi để dùng lại sau này. Pricing Calculator lấy các dòng benchmark từ đây.',
  searchT: 'Tìm một bảng',
  searchB: 'Gõ để thu hẹp các thẻ theo style, tên file, season hoặc vendor.',
  importT: 'Nạp bảng mới',
  importB: 'Chọn file Excel (.xlsx) của vendor. Các dòng được đọc và đối chiếu với giá in bên cạnh; dòng nào không khớp sẽ được nêu tên chứ không bị bỏ đi lặng lẽ.',
  cardT: 'Mở một bảng',
  cardB: 'Bấm vào thẻ để xem các dòng: Skin, CMT, OH&P và frame so với tổng mà chính bảng ghi. Sửa để đặt season, vendor và ghi chú; Xóa gỡ bảng khỏi thư viện.',
};
const zh = {
  introT: '供应商成本表库',
  introB: '保存供应商发来的 in-line 成本表，方便日后复用。Pricing Calculator 的基准行就取自这里。',
  searchT: '查找成本表',
  searchB: '输入文字即可按款式、文件名、季度或供应商缩小卡片范围。',
  importT: '登记新的成本表',
  importB: '选择供应商的 Excel 工作簿（.xlsx）。系统会读取各行，并与旁边印出的成本核对；对不上的行会逐条列出，而不是悄悄丢弃。',
  cardT: '打开成本表',
  cardB: '点击卡片查看各行：Skin、CMT、OH&P、框架，以及成本表自身给出的合计。编辑可设置季度、供应商和备注，删除会把该成本表从库中移除。',
};
const dictionary = { ns: 'tourCostSheets', en, ko, vi, zh };
export default dictionary;
